import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'react-bootstrap-icons';
import { useProjects } from '../../contexts/ProjectContext';
import { useUsage } from '../../contexts/UsageContext';
import ProjectTable from './ProjectTable';
import ProjectModal from './ProjectModal';
import ProjectLimitModal from '../common/ProjectLimitModal';
import Footer from '../Footer';
import { Project } from '../../types/project.types';
import './ProjectManager.css';

const ProjectManager: React.FC = () => {
  const navigate = useNavigate();
  const { projects, updateProject, openNewProjectDialog } = useProjects();
  const { canCreateProject, usageStats } = useUsage();
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingProject, setEditingProject] = useState<Project | null>(null);
  const [showLimitModal, setShowLimitModal] = useState(false);

  // Check if there are any non-archived projects
  const hasProjects = projects.filter(p => !p.isArchived).length > 0;

  const handleCreateProject = () => {
    if (!canCreateProject()) {
      setShowLimitModal(true);
      return;
    }
    openNewProjectDialog({ onLimitError: () => setShowLimitModal(true) });
  };

  const handleEditProject = (project: Project) => {
    setEditingProject(project);
    setShowEditModal(true);
  };

  const handleSelectProject = (project: Project) => {
    navigate(`/projects/${project.id}`);
  };

  const handleSaveProject = async (data: any) => {
    if (editingProject) {
      await updateProject(editingProject.id, data);
    }
  };

  return (
    <>
      <Container fluid className="py-4">
        <Row>
          <Col>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h1>projects</h1>
              {hasProjects && (
                <Button variant="primary" onClick={handleCreateProject} className="new-project-btn">
                  <Plus className="me-2" /> Start New Project
                </Button>
              )}
            </div>

            <ProjectTable
              onSelectProject={handleSelectProject}
              onEditProject={handleEditProject}
              onCreateProject={handleCreateProject}
              showArchived={false}
            />
          </Col>
        </Row>

        <ProjectModal
          show={showEditModal}
          onHide={() => setShowEditModal(false)}
          onSave={handleSaveProject}
          project={editingProject}
          title="Edit Project"
        />

        <ProjectLimitModal
          show={showLimitModal}
          onHide={() => setShowLimitModal(false)}
          planName={usageStats?.plan || 'starter'}
        />
      </Container>
      <Footer />
    </>
  );
};

export default ProjectManager;
